import { Box, Grid, Typography, useTheme } from "@mui/material";
import { GetClosedCohortQuery } from "generated-graphql/graphql";
import { useMemo } from "react";
import { SummaryMetric } from "../SummaryMetric";

type CohortSummaryData = NonNullable<NonNullable<GetClosedCohortQuery["cohort"]>['closedCohortSummary']>;

interface ColoradoSummaryProps {
  cohortSummaryData: CohortSummaryData;
}

export function ColoradoSummary({ cohortSummaryData }: ColoradoSummaryProps) {
  const theme = useTheme();

  const summaryData = useMemo(() => {
    return {
      readyCount:
      cohortSummaryData.coChemicalCounts?.facilitiesWithAtLeastOneRfcOverThreshold ?? 0,
      totalChemicals: cohortSummaryData.coChemicalCounts?.totalRfcsOverThreshold ?? 0,
    };
  }, [cohortSummaryData.coChemicalCounts]);

  return (
    <Box
      sx={{
        mt: 3,
        pt: 2,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500 }}>
        Colorado Details
      </Typography>

      <Grid container spacing={3}>
        <SummaryMetric
          label="Total number of facilities with at least one chemical above reporting thresholds"
          value={summaryData.readyCount}
        />

        <SummaryMetric
          label="Total number of chemicals above reporting thresholds across all facilities"
          value={summaryData.totalChemicals}
        />
      </Grid>
    </Box>
  );
}
